<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="8" width="12" height="8" rx="1.5" fill="currentColor" />
<rect x="8" y="2" width="8" height="4" rx="1" fill="currentColor" opacity="0.35" />
<rect x="4" y="8" width="8" height="4" rx="1" transform="rotate(90 4 8)" fill="currentColor" opacity="0.35" />
<rect x="24" y="8" width="8" height="4" rx="1" transform="rotate(90 24 8)" fill="currentColor" opacity="0.35" />
<rect x="8" y="18" width="8" height="4" rx="1" fill="currentColor" />
</svg>
